<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="halftitle"><a id="pI"></a>MARIE-ANTOINETTE</p>
<p class="bio-break"><b>John Hardman</b> is one of the world’s leading experts on the French Revolution and the author of several distinguished books on the subject.</p>
<p class="linespace"></p>
<p class="praise-txt">Further praise for <i>Marie-Antoinette</i>:</p>
<p class="linespace"></p>
<p class="praise-txt">‘Insightful . . . The impressive depth of Hardman’s knowledge of the old regime’s factional court politics makes it essential reading for anyone who wants to know more about the decision-making that led France into revolution – decisions in which the queen played an active part.’ Marisa Linton, <i>BBC History Magazine</i></p>
<p class="linespace"></p>
<p class="praise-txt">‘Presents [Marie-Antoinette] as much more than a symbol whose meaning is in the eye of her beholder. In Hardman’s telling she is neither martyr nor voluptuary but rather a serious participant in politics.’ Lynn Hunt, <i>New York Review of Books</i></p>
<p class="linespace"></p>
<p class="praise-txt">‘It is worth making time for John Hardman’s <i>Marie-Antoinette</i> . . . [This] is a well written and sympathetic life of a woman out of her depth in the world of politics, and a good companion piece to the same author’s life of her husband Louis XVI.’ Jonathan Sumption, <i>Spectator</i> Books of the Year</p>
<p class="linespace"></p>
<p class="praise-txt">‘Hardman is far more than a biographer: his works are key to understanding the politics of the reign of Louis XVI. Steeped in the original sources and well able to decode the plots and schemes of the factions, this is both an entertaining and convincing new interpretation of the tragic queen.’ Peter Campbell, author of <i>Power and Politics in Old Regime France</i></p>
<p class="linespace"></p>
<p class="praise-txt">‘Superb. Hardman draws upon his vast knowledge of the period to present a new, deeply researched and compelling portrait of a much-maligned queen.’ Julian Swann, author of <i>Exile, Imprisonment, or Death</i></p>
<p class="linespace"></p>
<p class="praise-txt">‘A fresh perspective grounded in robust scholarship, <i>Marie-Antoinette</i> offers readers new insight into the political role of the last Queen of France.’ Will Bashor, author of <i>Marie Antoinette’s Darkest Days</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?83b880a2